export default {
  downloadFormat: {
    CM10: 'CM10',
    pdf: 'Ficheiro PDF',
    copy: 'Cópia do original assinada digitalmente',
    ubl: 'UBL 1.0',
    facturae_3_2: 'Facturae 3.2',
    facturae_3_2_1: 'Facturae 3.2.1',
    facturae_3_2_2: 'Facturae 3.2.2',
    owner: 'Formato proprietário'
  },
  acceptedBills: 'As faturas foram aceites com sucesso.',
  rejectedBills: 'As faturas foram rejeitadas com sucesso.',
  unrejectedBills: 'As faturas foram des-rejeitadas com sucesso.',
  cancelledBills: 'As solicitações de anulação das faturas foram realizadas com sucesso.',
  acceptedCancel: 'A anulação das faturas foi aceita com sucesso.',
  rejectedCancel: 'A anulação das faturas foi rejeitada com sucesso.',
  sentBills: 'As faturas foram enviadas com sucesso.',
  deletedBills: 'As faturas foram eliminadas com sucesso.',
  financingSuccessed: 'O seu processo de solicitação de financiamento foi iniciado com sucesso.'
}